import { FC, useMemo } from 'react';
import { Menu, Typography } from 'antd';
import type { MenuProps } from 'antd';
import styles from './style.module.css';

export interface Props {
  selectedKey: string;
  updateData: (key: string) => void;
}

type MenuItemType = NonNullable<MenuProps['items']>[number];

const CreateCampaignMenu: FC<Props> = ({ updateData, selectedKey }: Props) => {
  const { Title } = Typography;

  const items: MenuItemType[] = useMemo(
    () => [
      { label: 'Основные настройки', key: 'main' },
      { label: 'Список телефонов', key: 'phones' },
    ],
    [],
  );

  return (
    <div className={styles.blockMenu}>
      <Title className={styles.blockTitle} level={3}>
        Создание кампании
      </Title>
      <Menu
        mode="horizontal"
        onClick={(e) => updateData(e.key)}
        selectedKeys={[selectedKey]}
        defaultSelectedKeys={['main']}
        items={items}
        className={styles.menu}
      />
    </div>
  );
};

export default CreateCampaignMenu;
